export default __webpack_public_path__ + "static/allProjects4-e2c23ede07d4e5300aad6aee43dab585.png";